import Cookies from "js-cookie";

export const fetchAIResponse = async (url, input, model, messages, aiCharacter, abortController) => {
  console.log("debug", "into fetcher")

  let messagesToSend = [...messages];
  if (aiCharacter) {
    url = url + `?character=${aiCharacter.toLowerCase()}`
  }
  messagesToSend.push({ role: "user", content: input })
  console.log("To send", messagesToSend);
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${Cookies.get("token")}`,
        "session" : "x"
      },
      body: JSON.stringify({
        model: model,
        messages: messagesToSend,
        stream: true,
        with_system_prompt: aiCharacter ? `` : ``
      }),
      signal: abortController?.signal
    });

    return response;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error("Error fetching AI response:", error);
    throw error;
  }
};
